import { FC } from "react";
import theme from "@styles/theme";
import { useMemo } from "react";
import useAppSelector from "@hooks/useAppSelector";
import useAppDispatch from "@hooks/useAppDispatch";
import { useTranslation } from "react-i18next";
import { selectIssueById } from "@store/issue/issueSelectors";
import { Issue } from "@store/issue/types";
import { deleteIssueBatch } from "@store/issue/issueThunk";

const selectById = () => selectIssueById;

interface IssueRowProps {
  issueId: Issue["id"];
}

const IssueRow: FC<IssueRowProps> = ({ issueId }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const selectIssue = useMemo(selectById, [issueId]);
  const issue = useAppSelector(({ issue }) => selectIssue(issue, issueId));

  const onRemove = () => dispatch(deleteIssueBatch({ issueIds: [issueId] }));

  if (issue === undefined) return null;
  const { label, description } = issue;

  return (
    <div className="container" key={issueId}>
      <div className="text">
        <h5>{label}</h5>
        <p>
          {description &&
            description?.length > 0 &&
            t("hk.description", { description })}
        </p>
      </div>
      <img onClick={onRemove} src="/icons/icon-remove.svg" />
      <style jsx>{`
        .container {
          text-align: left;
          display: flex;
          flex-direction: row;
          flex: 1;
          justify-content: space-between;
        }
        .text {
          padding: 4px 8px;
        }
        .container:nth-child(odd) > .text {
          background: ${theme.colors.mono200};
        }
        p {
          margin-top: 4px;
        }
        h5 {
          font-weight: bold;
        }
        img {
          width: 20px;
          margin-left: 8px;
          height: auto;
          background-color: #ffffff;
          z-index: 2;
        }
        img:hover {
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default IssueRow;
